<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" :denny-color="'#8d8d8d'" :apply-text="'Скачать'" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-alert type="info" outlined class="mt-5"  v-if="choices.order.length > 1">
      <span>Для загрузки <b>полного списка</b> заявок оставьте поля пустыми и нажмите "Скачать"</span>
    </v-alert>
    <v-alert type="info" outlined class="mt-5"  v-if="choices.order.length === 1">
        <span>Для загрузки <b>полного списка</b> постоянных пропусков нажмите "Скачать"</span>
    </v-alert>
    <v-select
        v-if="choices.order.length > 1"
        class="pt-2"
        v-model="filters.dump"
        label="Заявки"
        outlined
        single-line
        flat
        :items="choices.order"
    >
    </v-select>
    <v-select
        :class="choices.order.length > 1 ? '' : 'pt-2'"
        v-if="filters.dump !== 'overdue_departures' && choices.order.length > 1"
        v-model="filters.order_type"
        label="Тип пропуска"
        outlined
        single-line
        flat
        :items="choices.order_type"
    >
    </v-select>
    <v-select
        v-if="filters.dump !== 'overdue_departures' && choices.order.length > 1"
        v-model="filters.order_status"
        label="Статус заявки"
        outlined
        single-line
        flat
        :items="choices.order_status"
    >
    </v-select>
    <v-row no-gutters
           :class="choices.order.length > 1 ? '' : 'pt-2'"
           v-if="choices.order.length > 1"
    >
      <v-col cols="12" md="6" class="pr-md-3">
        <v-text-field
            outlined
            v-model="filters.start_date" type="date"
            label="Дата начала действия пропуска" clearable>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
            outlined
            v-model="filters.end_date" type="date"
            label="Дата окончания действия пропуска" clearable>
        </v-text-field>
      </v-col>
    </v-row>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import admin from "@/modules/admin/routers/names";
import entitled from "@/modules/entitled/routers/names";
import viewer from "@/modules/viewer/routers/names";
import { addGetParameters } from "@/helper/requests";

export default {
  name: "OrdersDownloadFileDialog",
  props: {
    opened: Boolean,
    choices: Object,
    unloadingFrom: Function,
    names: String
  },
  mixins: [FormErrorsMixin],
  components: {
    ScrollCenterDialog
  },
  data() {
    return {
      save_loading: false,
      filters: {
        "dump": "orders",
        "order_type": null,
        "order_status": null,
        "start_date": null,
        "end_date": null
      }
    }
  },
  computed: {
    form_title () {
      return this.choices.order.length === 1 ? "Параметры выгрузки списка пропусков" : "Параметры выгрузки списка заявок"
    }
  },
  methods: {
    ...mapActions({
      loadOrderTypeChoices: "choices/loadOrderTypeChoices",
      loadOrderStatusChoices: "choices/loadOrderStatusChoices"
    }),
    close(){
      this.$emit("close", false)
    },
    save(url = undefined){
      this.save_loading = true

      this.unloadingFrom({
        url: url,
        urlAppend: (url) => {
          return addGetParameters(
              url,
              this.filters
          )
        },
        finalizer: (data) => {
          this.save_loading = false
          if (this.names === "admin") this.$router.push({name: admin.ORDERS.FILE, params: {idFile: data.unloading}}).catch(() => {})
          if (this.names === "entitled") {
              if (this.filters.dump === "regular_passes") {
                  this.$router.push({name: entitled.REGULAR_PASSES.FILE, params: {idFile: data.unloading}}).catch(() => {})
              } else {
                  this.$router.push({name: entitled.ORDERS.FILE, params: {idFile: data.unloading}}).catch(() => {})
              }
          }
          if (this.names === "viewer") this.$router.push({name: viewer.ORDERS.FILE, params: {idFile: data.unloading}}).catch(() => {})
        }
      })
    }
  },
  created() {
      if (this.choices.order.length === 1) {
          this.filters.dump = "regular_passes"
      }
  }
}
</script>

<style scoped>

</style>
